import React from "react";
import { $t } from "~/i18n.js";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";

export const ImportStatus = ({ importStatus }) => {
  if (!importStatus) return null;
  return {
    title: $t("Status"),
    width: 120,
    render: (_, record) => {
      const status = importStatus[record.id];
      return (
        <div>
          {record.error && (
            <Tag icon={<ExclamationCircleOutlined />} color="error">
              {record.error}
            </Tag>
          )}
          {!record.error && status === "skipped" && (
            <Tag color="orange">{$t("Overgeslagen")}</Tag>
          )}
          {!record.error && status === "loading" && (
            <Tag icon={<SyncOutlined spin />} color="processing" />
          )}
          {!record.error && status === "success" && (
            <Tag icon={<CheckCircleOutlined />} color="success" />
          )}
          {!record.error && status?.startsWith("fail") && (
            <Tag icon={<ExclamationCircleOutlined />} color="warning">
              {status}
            </Tag>
          )}
        </div>
      );
    },
  };
};
